import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useStatusPalette } from "../../utils/statusColors";
import { Sidebar, SidebarList, buildSessionStatusStyles } from "./agentSessionsPanelUtils";

function CollapsedSidebar({
  sessions,
  selectedSessionId,
  isNewChat,
  onSelectSession,
  onNewChat,
  onExpandSidebar,
  onSessionsListScroll,
}) {
  const _sp = useStatusPalette();
  const statusMap = buildSessionStatusStyles(_sp);

  return (
    <Sidebar sx={{ width: "140px" }}>
      <Box
        sx={{
          px: 1,
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          alignItems: "center",
          height: "57px",
          boxSizing: "border-box",
        }}
      >
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 600,
            color: "text.secondary",
            flex: 1,
            whiteSpace: "nowrap",
          }}
        >
          Sessions
        </Typography>
        <IconButton
          size="small"
          onClick={onNewChat}
          sx={{
            p: "2px",
            color: "text.disabled",
            "&:hover": { color: "text.primary" },
          }}
        >
          <AddIcon sx={{ fontSize: 16 }} />
        </IconButton>
        <IconButton
          size="small"
          onClick={onExpandSidebar}
          sx={{ p: "2px", color: "text.secondary" }}
        >
          <ChevronRightIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
      <SidebarList onScroll={onSessionsListScroll}>
        {sessions.map((s) => {
          const isActive =
            !isNewChat && s.chatSessionId === selectedSessionId;
          const sStyle = statusMap[s.status] || statusMap.IN_PROGRESS;
          return (
            <Box
              key={s.chatSessionId}
              onClick={() => onSelectSession(s.chatSessionId)}
              sx={{
                px: 1,
                py: 1,
                cursor: "pointer",
                backgroundColor: isActive
                  ? "background.paper"
                  : "transparent",
                borderLeft: isActive
                  ? "3px solid"
                  : "3px solid transparent",
                borderLeftColor: isActive ? "text.primary" : "transparent",
                transition: "background-color 150ms ease",
                "&:hover": {
                  backgroundColor: isActive
                    ? "background.paper"
                    : "action.hover",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.75,
                }}
              >
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    backgroundColor: sStyle.color,
                    flexShrink: 0,
                  }}
                />
                <Typography
                  sx={{
                    fontSize: 11,
                    fontWeight: isActive ? 600 : 500,
                    color: "text.primary",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {s.title || "Untitled"}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </SidebarList>
    </Sidebar>
  );
}

export default React.memo(CollapsedSidebar);
